import React from "react";
import { Grid } from "@material-ui/core";

import { StandAloneAttachments } from "../../modules/StandAloneAttachments/StandAloneAttachments";

const AttachmentsComponent = ({ attachments, isLoading, loanId, loanPostAttachment, loanPutAttachment, loanDeleteAttachment, authentication }) => (
  <Grid container>
    <StandAloneAttachments
      files={attachments}
      authentication={authentication}
      isLoading={isLoading}
      onAdd={file => loanPostAttachment({ file, loanId })}
      onUpdate={file => loanPutAttachment({ file, loanId })}
      onRemove={file => loanDeleteAttachment({ fileId: file.id, loanId })}
    />
  </Grid>
);

export default (AttachmentsComponent);

